export default __webpack_public_path__ + "static/media/bondly-usdt.677ba600.svg";